import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "navigation-report",
  "use": "navigation-report-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"navigation-report\"><path d=\"M9.6 6H6.4a.8.8 0 00-.8.8v6.6a.8.8 0 00.8.8h3.2a.8.8 0 00.8-.8V6.8a.8.8 0 00-.8-.8zm5.6-3.2H12a.8.8 0 00-.8.8v9.8a.8.8 0 00.8.8h3.2a.8.8 0 00.8-.8V3.6a.8.8 0 00-.8-.8zM4 9.8H.8a.8.8 0 00-.8.8v2.8a.8.8 0 00.8.8H4a.8.8 0 00.8-.8v-2.8a.8.8 0 00-.8-.8z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/navigation-report.svg
// module id = bBur
// module chunks = 39 44